import axiosInstance from '@/services/axiosInstance'

async function unlinkRulesGroupsMultiple (data) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: 'api/reglas/desvincularreglasgrupos',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { unlinkRulesGroupsMultiple }
